<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.57031 5.92993L3.50031 11.9999L9.57031 18.0699" stroke="#00939F" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M20.5 12H3.67" stroke="#00939F" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
